// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__0QeVM","isOpen":"styles_isOpen__FKeIf","close":"styles_close__0nR21","overlay":"styles_overlay__3SJ6p"};